import React, { useMemo } from 'react';
import { toHTML } from "../editor/helper/toHTML.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function Markdown({
  content,
  dangerouslyAllowUnsanitizedHTML = false
}) {
  const sanitizedHTML = useMemo(() => {
    return content ? toHTML(content, dangerouslyAllowUnsanitizedHTML) : '';
  }, [content, dangerouslyAllowUnsanitizedHTML]);
  return /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: {
      __html: sanitizedHTML
    }
  });
}